import { validateEmail } from '@angle/utils'
import React, { useState } from 'react'
import { Modal } from 'react-angle-dashboard-components'
import {
  CompanyInput,
  CompanyModalTitle,
  ContinueButton,
  ModalContentWrapper
} from './styles'

interface CompanyNameModalProps {
  show: boolean
  onHide: Function
  onContinue: (companyName: string, businessEmail: string) => void
}

export const CompanyNameModal: React.FC<CompanyNameModalProps> = ({
  show,
  onHide,
  onContinue
}) => {
  const [companyName, setCompanyName] = useState('')
  const [businessEmail, setBusinessEmail] = useState('')
  const [isLoading, setLoading] = useState(false)
  const [emailIsInvalid, setEmailIsInvalid] = useState(false)

  const onClickContinue = async () => {
    setEmailIsInvalid(!validateEmail(businessEmail))
    if (!validateEmail(businessEmail)) return
    setLoading(true)
    await onContinue(companyName, businessEmail)
    setLoading(false)
  }

  return (
    <Modal show={show} onHide={onHide} backdrop="static" centered>
      <Modal.Body>
        <ModalContentWrapper>
          <CompanyModalTitle>Help Us Save Your Progress</CompanyModalTitle>
          <CompanyInput
            value={companyName}
            onChange={(e: any) => setCompanyName(e.target.value)}
            placeholder="Company Name"
          />
          <CompanyInput
            type="email"
            value={businessEmail}
            onChange={(e: any) => setBusinessEmail(e.target.value)}
            onBlur={() => setEmailIsInvalid(!validateEmail(businessEmail))}
            placeholder="Business Email"
            isInvalid={emailIsInvalid}
          />

          <ContinueButton
            variant="primary"
            disabled={
              companyName.length === 0 ||
              businessEmail.length === 0 ||
              isLoading
            }
            onClick={onClickContinue}
          >
            Continue
          </ContinueButton>
        </ModalContentWrapper>
      </Modal.Body>
    </Modal>
  )
}

export default CompanyNameModal
